import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ReadingPaneNewIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 16)}
      strokeWidth="1.5"
      {...svgProps}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      viewBox="0 0 28.447 17.858"
    >
      <path d="M6.986 16.964H1.997A1.248 1.248 0 01.75 15.717V1.997A1.247 1.247 0 011.997.75h12.472a1.247 1.247 0 011.247 1.247v5.612M6.986 4.491h4.989M4.492 8.233h7.483M4.492 11.975h2.91" />
      <circle cx="13.977" cy="13.99" r="3.118" />
      <circle cx="22.708" cy="13.99" r="3.118" />
      <path d="M17.095 14.049a1.247 1.247 0 112.494 0M27.697 13.99h-1.871M10.859 13.99H8.988" />
    </SVG>
  );
};
